import { forwardRef, useId } from "react";
import { LucideProps } from "lucide-react";

const BRACE =
  "M28 10H24C18 10 15 13 15 19V24C15 28 11 28 11 32C11 36 15 36 15 40V45C15 51 18 54 24 54H28V47H25C23 47 22 46 22 43V40C22 36 20 34 18 32C20 30 22 28 22 24V21C22 18 23 17 25 17H28Z";

// Monochrome in UI controls; product branding explicitly opts into color.
const NexumAPI = forwardRef<SVGSVGElement, LucideProps & { colored?: boolean }>(
  ({ colored = false, ...props }, ref) => {
    const id = useId();
    const lowerWave = `${id}-lower`;
    const upperWave = `${id}-upper`;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        {...props}
        ref={ref}
        viewBox="0 0 64 64"
        stroke="none"
      >
        {colored && (
          <defs>
            <clipPath id={lowerWave}>
              <path d="M0 34C9 27 20 43 32 33V64H0Z" />
            </clipPath>
            <clipPath id={upperWave}>
              <path d="M0 0H32V25C24 25 19 34 12 31C7 29 4 29 0 31Z" />
            </clipPath>
          </defs>
        )}
        <path d={BRACE} fill={colored ? "#5e59a7" : "currentColor"} />
        {colored && (
          <path d={BRACE} fill="#516ab2" clipPath={`url(#${lowerWave})`} />
        )}
        <g transform="translate(64 0) scale(-1 1)">
          <path d={BRACE} fill={colored ? "#499ed7" : "currentColor"} />
          {colored && (
            <path d={BRACE} fill="#4ec7e5" clipPath={`url(#${upperWave})`} />
          )}
        </g>
      </svg>
    );
  },
);
NexumAPI.displayName = "NexumAPI";
export default NexumAPI;
